import { connect } from 'react-redux';
import { StoreState } from '../../../reducers/index';
import GDPRCookie from '../../../components/CookieNotification/GDPRCookie';
import Utils from '../../../utils';
import { DEFAULT_COOKIE_URLS } from '../constants';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos,
		appInfos,
		offlineManager,
		GDPRCookie: { isDisplayed },
		galleryInfos: { template: { cookie } },
		i18n: { locale },
	} = state;

	const isGdprEnabled = !!cookie && cookie.gdpr === 'true';
	const isGalleryReady = Utils.isGalleryReady(galleryInfos, offlineManager, appInfos);
	const shouldInit = isGdprEnabled && isGalleryReady;
	const url = cookie && cookie.url || DEFAULT_COOKIE_URLS[locale];
	const language = locale.split('_')[0];

	return {
		shouldInit,
		isDisplayed,
		url,
		language,
	};
};

export default connect(mapStateToProps)(GDPRCookie);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CookieNotification/GDPRCookie/index.ts